import { Component, Input } from '@angular/core';
import { NbDialogRef, NbGlobalPhysicalPosition, NbIconConfig, NbToastrService } from '@nebular/theme';
import { ConfirmModalComponent } from '../../modals/confirm-modal.component';

import { LanguageService, GameService, RoleService } from '../../../_services/index';

import { trigger, transition, animate, style } from '@angular/animations';
import { NbDialogService } from '@nebular/theme';

import { diffChars }  from '../../template-update/character';
import { firstValueFrom } from 'rxjs';

@Component({
    selector: 'ngx-role-changes-modal',
    templateUrl: 'role-changes-modal.component.html',
    styleUrls: ['role-changes-modal.component.scss'],
    animations: [
        trigger('slideInOut', [
            transition(':enter', [
                style({ opacity: 0 }),
                animate('200ms', style({ opacity: 1 })),
            ]),
            transition(':leave', [
                animate('100ms', style({ opacity: 0 })),
            ])
        ])
    ],
    standalone: false
})
export class RoleChangesModalComponent {

  positions = NbGlobalPhysicalPosition;
  gameVisibly = [];
  //loadData = false;
  templateRoles;
  templateId = '';
  games;
  //missions = []
  //changeExist = true
  loading = false;
  gamesChanges=[]
  currentLang = '';

  @Input() data;

  constructor(protected ref: NbDialogRef<RoleChangesModalComponent>,
    public roleService: RoleService,
    public languageService: LanguageService,
    private toastrService: NbToastrService,
    private dialogService: NbDialogService,
    private gameService: GameService) {
  }

  ngOnInit(){
    this.checkForChanges(this.data);
  }

  async checkForChanges(data){
    this.loading = true;
    this.templateId = data.templateId;
    this.currentLang = data.currentLang;
    this.games = data.games;
    this.templateRoles = data.templateRoles
    
    let start = new Date().getTime();
    console.log('start-list template missions');
    let gamesChanges = [];

    console.log('start-list all games roles');
    for (let i = 0; i < this.games.length; i++) {
      this.games[i].roles = await firstValueFrom(this.roleService.listRoles(`games/${this.games[i].id}/roles`));
    } 
    console.log('Assign roles to games');
    for(let i = 0; i < this.templateRoles.length; i++){
      for(let j = 0; j < this.games.length; j++){
        //verification from template to game
        let role;
        role = this.games[j].roles.find(r => r.id == this.templateRoles[i].id)
        if(!role){
          //Template object does not exist in the game
          let index;
          index = gamesChanges.findIndex(game => game.gameId == this.games[j].id);
          if(index >= 0){
            this.pushGameChange(gamesChanges, index, this.templateRoles[i], null);
          }else{
            this.pushNewChange(gamesChanges, this.games[j], this.templateRoles[i], null);
          }
        } else {
          //Template object exist in the game
          let index
          let params = ['labels', 'description', 'pictureLastUpdate', 'filePath']
          for(let k = 0; k < params.length; k++) {
            const param = params[k];
            let isRoleDiff:boolean
            if(param == 'pictureLastUpdate' || param == 'filePath'){
              isRoleDiff = role[param] != this.templateRoles[i][param];
            }else{
              isRoleDiff = role[param][this.languageService.currentLang] != this.templateRoles[i][param][this.languageService.currentLang];
            }
            if(isRoleDiff){
              index = gamesChanges.findIndex(change => change.gameId == role.gameId);
              if(index >= 0){
                this.pushGameChange(gamesChanges, index, this.templateRoles[i], role)
              }else{
                this.pushNewChange(gamesChanges, this.games[j], this.templateRoles[i], role)
              }
            }
          }
        }
      }  
    }
    //verification from game to template
    for(let game of this.games){
      for(let role of game.roles){
        let roleGameTemplate = this.templateRoles.find(obj=> obj.id == role.id)
        if(!roleGameTemplate){
          let index = gamesChanges.findIndex(gameChange => gameChange.gameId == game.id);
          if(index >= 0){
            this.pushGameChange(gamesChanges, index, null, role)
          }else {
            this.pushNewChange(gamesChanges, game, null, role)
          }
        }
      }
    }
    let stop = new Date().getTime();
    console.log('Data treatment took '+((stop-start)/1000)+'sec');
    this.games = this.games;
    this.gamesChanges = gamesChanges;
    this.loading = false;
  }

  getGameById(gameId){
    let game =  this.games.find(game => game.id == gameId);
    return game;
  }

  pushGameChange(gamesChanges, index, templateRoles, role){    
    gamesChanges[index].changes.push({
      templateId: this.templateId,
      template: templateRoles ? templateRoles : {labels: {}, description: {}, pictureUrl: ''},
      roleGame: role,
    })
  }

  pushNewChange(gamesChanges, games, templateRoles, role){
    gamesChanges.push({
      gameId: games.id,
      name: games.name,
      changes:[{
        templateId: this.templateId,
        template: templateRoles ? templateRoles : {labels: {}, description: {}, pictureUrl: ''},
        roleGame: role,
      }]
    })
  }

  deleteRole(role, i, j){
    this.dialogService.open(ConfirmModalComponent, { 
      context: {
        title: 'Confirmation',
        message: `Do you want to delete role '`+role.labels[this.languageService.currentLang]+`'?`
      }, closeOnBackdropClick: false
    })
    .onClose.subscribe(async res => {
      console.log('Dialog returns:'+res);
      if(res){
        console.log('Delete role:'+role.collectionPath);
        //comment for tests
        //await this.roleService.deleteRole(role);
        if(this.gamesChanges[i].changes.length == 1){
          this.gamesChanges.splice(i, 1);
        }
        else{
          this.gamesChanges[i].changes.splice(j, 1);
        }
      }
    });
  }

  close() {
    this.ref.close();
  }

  getDiffAttributes(from, to, param){
    if(from && to){
      let diff = diffChars(from, to , {})
      if( diff.length > 1 ){
        return this.setNewColoredAttribut(diff, param)
      } else return to
    } else if (!from && to){
      return '<span class="added">'+to + '</span>'
    } else return to
  }
  
  ngAfterViewChecked(){
    const added = document.querySelectorAll<HTMLElement>('.added') 
    added.forEach(function(item) {
      item.style.color = '#1dc864',
      item.style.fontSize = '16px';
    });
    const removed = document.querySelectorAll<HTMLElement>('.removed')
    removed.forEach(function(item) {
      item.style.color = 'red';
      item.style.fontSize = '16px';
    }); 
  }

  setNewColoredAttribut(diff, param){
    let att = ''
    for (let i = 0; i < diff.length; i++) {
      const element = diff[i];
      if(!element.removed && !element.added){
        att += element.value 
      }
      if(param === 'to'){
        if(!element.removed && element.added){
          att += '<span class="added">'+ element.value + '</span>'
        }
      }else{
        if(!element.removed && element.added){
          att += '<span class="removed">'+ element.value + '</span>'
        }
      }
    }
    return att
  }
  
  async applyChanges(game, roleTemplate, roleGame, i, j){
    let result;
    let error;
    console.log('Game roles are not activated:'+JSON.stringify(game));
    if(!game.hasRoles){
      console.log('Game roles are not activated');
      await this.gameService.updateGame(game.gameId, {hasRoles: true})
    }
    if(!roleGame) {
      console.log('Template role: '+JSON.stringify(roleTemplate));

      let data ={
        collectionPath: `games/${game.gameId}/roles`,
        gameId            : game.gameId,
        id                : roleTemplate.id,
        orderNum          : roleTemplate.orderNum,
        labels            : roleTemplate.labels,
        description       : roleTemplate.description,
        pictureLastUpdate : roleTemplate.pictureLastUpdate,
        filePath          : roleTemplate.filePath,
        pictureUrl        : roleTemplate.pictureUrl
      }
      
      console.log('Create role: '+JSON.stringify(data));
      this.roleService.setRole(data).then(value => {
        result = value
        this.changeShowToast(value, 'Add')
        if(this.gamesChanges[i].changes.length == 1){
          this.gamesChanges.splice(i, 1);
        }
        else{
          this.gamesChanges[i].changes.splice(j, 1);
        }
      }, err => {
        error = err
        console.log('error :',error)
        this.changeShowToast('error', 'Add')
      });
    }else{
      let data ={
        collectionPath: `games/${game.gameId}/roles`,
        orderNum          : roleTemplate.orderNum,
        labels            : roleTemplate.labels,
        description       : roleTemplate.description,
        pictureLastUpdate : roleTemplate.pictureLastUpdate,
        filePath          : roleTemplate.filePath,
        pictureUrl        : roleTemplate.pictureUrl
      }
      this.roleService.updateRole(roleGame, data).then(value => {
        result = value
        this.changeShowToast(value, 'Apply changes')
        if(this.gamesChanges[i].changes.length == 1) this.gamesChanges.splice(i, 1)
        else this.gamesChanges[i].changes.splice(j, 1)
      }, err => {
        error = err
        this.changeShowToast('error', 'Apply changes')
        console.log('error', error)
      });
    }
  }

  changeShowToast(type , action){
    if(type == 'error'){
      this.showToast('Error', 'danger', `${action} roles failed`, 'close-outline');
    }
    else{
      this.showToast('Success', 'success', `Role successfully ${action}ed on game`, 'done-all-outline');
    }
  }

  showToast(type,status ,text, iconName) {
    const icon: NbIconConfig = { icon: iconName, pack: 'eva' };
    let duration = 5000
    let position = this.positions.TOP_RIGHT
    this.toastrService.show(type , text, { position, status, duration,icon });
  }

  applyAllChanges(){//!game.hasRoles
    this.dialogService.open(ConfirmModalComponent, { 
      context: {
        title: 'Confirmation',
        message: `Are you sure you want apply all changes?`
      }, closeOnBackdropClick: false
    })
    .onClose.subscribe(async res => {
      console.log('Dialog returns:'+res);
      if(res){
        for (let i = this.gamesChanges.length -1; i >= 0; i--) {
          const game = this.gamesChanges[i];
          let changes = game.changes;
          for (let j = changes.length -1; j >= 0; j--) {
            const change = changes[j];
            if(change.template?.id){
              await this.applyChanges(game, change.template, change.roleGame, i, j);
            }
            else{
              await this.deleteRole(change.roleGame, i ,j);
            }
          }
        }
      }
    });
  }

  toggleShowDetailGame(index) {
    this.gameVisibly[index] = this.gameVisibly[index]? !this.gameVisibly[index] : true;
  }
}